import React from "react";
import {VideoConvertor} from "../../components/my_tools/video_convert/videoConvertor";

interface IVideoConvert {
    globalTextColor: string;
}
export const VideoConvert: React.FC<IVideoConvert> = ({globalTextColor}) => {

    return (
        <div className={`text-[${globalTextColor}]`}>
            <VideoConvertor />
        </div>
    )
}
